import { SortType } from "src/utils/configs";

export const AptSortKeys = {
  DEAL_PRICE_AVR: {
    key: "dpa",
    sortBy: "currentInfo.dealPriceAvr",
    sortDir: SortType.DESC,
  },
  LEASE_PRICE_AVR: {
    key: "lpa",
    sortBy: "currentInfo.leasePriceAvr",
    sortDir: SortType.DESC,
  },
  DEAL_PRICE_PER_SPACE_AVR: {
    key: "dppsa",
    sortBy: "currentInfo.dealPricePerSpaceAvr",
    sortDir: SortType.DESC,
  },
  LEASE_PRICE_PER_SPACE_AVR: {
    key: "lppsa",
    sortBy: "currentInfo.leasePricePerSpaceAvr",
  },
  LEASE_PRICE_RATE_AVR: {
    key: "lpra",
    sortBy: "currentInfo.leasePriceRateAvr",
  },
  TOTAL_HOUSEHOLD: {
    key: "th",
    sortBy: "totalHousehold",
  },
  DEAL_LEASE_GAP: {
    key: "dlg",
    sortBy: "currentInfo.dealLeaseGapAvr",
  },
  DEAL_REAL_PRICE_AVR: {
    key: "drpa",
    sortBy: "currentInfo.dealRealPriceAvr",
  },
  LEASE_REAL_PRICE_AVR: {
    key: "lrpa",
    sortBy: "currentInfo.leaseRealPriceAvr",
  },
  RENT_REAL_PRICE_AVR: {
    key: "rrpa",
    sortBy: "currentInfo.rentRealPriceAvr",
  },
  UNDERVALUED_INDEX: {
    key: "uvi",
    sortBy: "currentInfo.undervalueIndex",
    sortDir: SortType.DESC,
  },
  UNDERVALUED_ASKING_INDEX: {
    key: "uvai",
    sortBy: "currentInfo.undervalueAskingIndex",
    sortDir: SortType.DESC,
  },
  UNDERVALUED_RELIABILITY: {
    key: "uvr",
    sortBy: "currentInfo.undervalueReliability",
    sortDir: SortType.DESC,
  },
  SIZE_UNDERVALUED_INDEX: {
    key: "suvi",
    sortBy: "currentInfo.sizeUndervalueIndex",
    sortDir: SortType.DESC,
  },
  SIZE_UNDERVALUED_ASKING_INDEX: {
    key: "suvai",
    sortBy: "currentInfo.sizeUndervalueAskingIndex",
    sortDir: SortType.DESC,
  },
  SIZE_UNDERVALUED_RELIABILITY: {
    key: "suvr",
    sortBy: "currentInfo.sizeUndervalueReliability",
    sortDir: SortType.DESC,
  },
  PRICE_UNDERVALUED_INDEX: {
    key: "puvi",
    sortBy: "currentInfo.priceUndervalueIndex",
    sortDir: SortType.DESC,
  },
  PRICE_UNDERVALUED_RELIABILITY: {
    key: "puvr",
    sortBy: "currentInfo.priceUndervalueReliability",
    sortDir: SortType.DESC,
  },
  FLOW_UNDERVALUED_INDEX: {
    key: "fuvi",
    sortBy: "currentInfo.flowUndervalueIndex",
    sortDir: SortType.DESC,
  },
  FLOW_UNDERVALUED_RELIABILITY: {
    key: "fuvr",
    sortBy: "currentInfo.flowUndervalueReliability",
    sortDir: SortType.DESC,
  },
  UPSIDE_INDEX: {
    key: "upi",
    sortBy: "currentInfo.upsideIndex",
    sortDir: SortType.DESC,
  },
  UPSIDE_RELIABILITY: {
    key: "upr",
    sortBy: "currentInfo.upsideReliability",
    sortDir: SortType.DESC,
  },
  BARGAIN_INDEX: {
    key: "bgi",
    sortBy: "currentInfo.bargainIndex",
    sortDir: SortType.DESC,
  },
  BARGAIN_RELIABILITY: {
    key: "bgr",
    sortBy: "currentInfo.bargainReliability",
    sortDir: SortType.DESC,
  },
};
